<mat-toolbar class="bar-filler"></mat-toolbar>
<div *ngIf="showFloorMessage === true" matRipple #floorbar [matRippleDisabled]="true" [matRippleColor]="rippleColor" class="fill-parent-widht floor-bar">
    <div class="floating-text">{{floorMessage}}</div>
</div>
<div *ngIf="showCouponMessage === true" matRipple #couponbar [matRippleColor]="rippleColor" class="fill-parent-widht coupon-bar" (click)="seeCoupons()">
    <div class="floating-text">{{couponMessage}}</div>
</div>
<div *ngFor="let item of itemList" matRipple class="no-outline pointer-cursor" (click)="itemClick(item)">
    <div class="flex-container-center small-margin">
        <div>
            <div class="flex-container-center">
                <div class="label">{{item.Name}}</div>
                <div class="small-detail small-margin">{{item.WaitTime}}</div>
            </div>
            <p class="detail summary-text"> {{item.Description}}</p>
        </div>
        <div class="float-right price-label small-margin">{{item.PriceString}}</div>
    </div>
    <mat-divider></mat-divider>
</div>
<div *ngIf="hasFee === true" class="no-outline pointer-cursor">
    <div class="flex-container-center">
        <div class="label small-margin">{{'Pages.CurrentOrder.DeliveryFee' | translate}}</div>
        <div class="float-right price-label">{{feeString}}</div>
    </div>
    <mat-divider></mat-divider>
</div>
<div *ngIf="coupon !== undefined && coupon !== null" class="flex-container-center" matRipple (click)="couponClick()">
    <div>
        <div class="label small-margin">{{coupon.Name}}</div>
        <div class="detail small-margin">{{coupon.ValueString}}</div>
    </div>
    <div class="float-right price-label small-margin">{{coupon.FinalValueString}}</div>
    <mat-divider></mat-divider>
</div>
<mat-toolbar class="bar-filler">
    <mat-toolbar-row>
        <P></P>
    </mat-toolbar-row>
    <mat-toolbar-row>
        <P></P>
    </mat-toolbar-row>
</mat-toolbar>
<mat-toolbar color="primary" class="top-bar">
    <button mat-icon-button (click)="back()">
        <mat-icon>arrow_back</mat-icon>
    </button>
    <div>{{'Pages.CurrentOrder.Title' | translate}}</div>
    <div class="filler"></div>
    <button *ngIf="showCouponIcon === true" class="couponbadge" mat-icon-button matBadge="{{couponCount}}" matBadgeColor="accent" matBadgePosition="after below" (click)="seeCoupons()">
        <img  src="/assets/img/coupon_icon.png" onerror="this.src='/assets/img/placeholder.png'" style="height: 90%;">
    </button>
</mat-toolbar>
<mat-toolbar class="bottom-bar" color="primary">
    <mat-toolbar-row>
        <div class="big-price-text">{{currentPriceString}}</div>
    </mat-toolbar-row>
    <mat-toolbar-row>
        <button mat-flat-button color="accent" disabled="{{!hasItem || !canSend}}" (click)="finishOrder()" class="fill-parent-width">{{'Pages.CurrentOrder.Finish' | translate}}</button>
    </mat-toolbar-row>
</mat-toolbar>